require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./baseinput"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./baseinput"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./baseinput")) : factory(root["./utils"], root["./baseinput"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__33__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[40],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__33__;

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(364);


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _NumberInput = _interopRequireDefault(__webpack_require__(365));

exports["default"] = _NumberInput["default"];
exports.NumberInput = _NumberInput["default"];

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _baUiCarbon = __webpack_require__(12);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baseinput = _interopRequireDefault(__webpack_require__(33));

var _StringResource = _interopRequireDefault(__webpack_require__(366));

var _NumberInput = _interopRequireDefault(__webpack_require__(368));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var STYLE_CLASS = _NumberInput["default"].numberInputClassName.replace(/"/g, '');

var DEFAULT_VALIDATION = new RegExp(/^[+-]{0,1}[0-9]*([.][0-9]*){0,1}$/); // accept only a valid string as input

var fixupValue = function fixupValue(value, useOnValueCallbacks) {
  if (value === undefined) {
    return undefined;
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'string' && value.length) {
    // old validation callbacks allowed invalid values, new validations do not
    if (!useOnValueCallbacks) {
      return value;
    }

    return String(Number(value));
  }

  return '';
}; // check value; and return a bound value and message when applicable


var checkValue = function checkValue(value, _ref) {
  var min = _ref.min,
      gtMin = _ref.gtMin,
      max = _ref.max,
      ltMax = _ref.ltMax,
      step = _ref.step,
      scale = _ref.scale,
      allowEmpty = _ref.allowEmpty;

  if ((value != null ? value : '') === '') {
    if (allowEmpty) {
      return {
        value: '',
        message: undefined,
        bound: false
      };
    }

    return {
      value: undefined,
      message: _StringResource["default"].get('empty'),
      bound: false
    };
  }

  if (!DEFAULT_VALIDATION.test(value)) {
    // not a possible number
    return {
      value: undefined,
      message: _StringResource["default"].get('empty'),
      bound: false
    };
  }

  if (isNaN(value)) {
    // not yet a nubmer
    return {
      value: undefined,
      message: _StringResource["default"].get('empty'),
      bound: false
    };
  }

  var number = Number(value);

  if (min !== undefined) {
    if (gtMin !== undefined) {
      // number must be > min
      if (!(number > Number(min))) {
        return {
          value: min + step,
          message: _StringResource["default"].get('minGT', {
            value: min
          }),
          bound: true
        };
      } // number must be >= min

    } else if (!(number >= Number(min))) {
      return {
        valuelue: min,
        message: _StringResource["default"].get('min', {
          value: min
        }),
        bound: true
      };
    }
  }

  if (max !== undefined) {
    if (ltMax !== undefined) {
      // number must be < max
      if (!(number < Number(max))) {
        return {
          value: max - step,
          message: _StringResource["default"].get('maxLT', {
            value: max
          }),
          bound: true
        };
      } // number must be <= max

    } else if (!(number <= Number(max))) {
      return {
        value: max,
        message: _StringResource["default"].get('max', {
          value: max
        }),
        bound: true
      };
    }
  }

  if (scale !== undefined) {
    var stringParts = String(number).split('.');

    if (stringParts[1]) {
      var numScale = Number(scale);

      if (numScale === 0) {
        return {
          value: stringParts[0],
          message: _StringResource["default"].get('scale0'),
          bound: true
        };
      } else if (stringParts[1].length > scale) {
        return {
          value: stringParts[0] + "." + stringParts[1].slice(0, numScale),
          message: _StringResource["default"].get('scale', {
            value: scale
          }),
          bound: true
        };
      }
    }
  }

  return {
    value: value,
    message: undefined,
    bound: false
  };
};

var NumberInput = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(NumberInput, _Component);

  function NumberInput(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_useOnValueCallbacks", !!_this.props.onValueChange || !!_this.props.onValueAccept);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (input) {
      _this._input = input;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChangeWithUpdate", function (v) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          validation = _this$props.validation;
      var value = v;

      if (validation) {
        if (!validation(value)) {
          return; // ignore input if invalid
        } // check if custom validated value can be constrained


        value = isNaN(value) ? value : _this._constrainedValue(value);
      } else {
        value = _this._constrainedValue(value) || _this.props.value;
      }

      onChange == null ? void 0 : onChange(value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onBlur = _this$props2.onBlur;

      _this.setState({
        displayValue: value
      });

      _this._onChangeWithUpdate(e.currentTarget.value);

      onBlur == null ? void 0 : onBlur(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (newValue, finalFireOnBlur) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          validation = _this$props3.validation,
          fireOnBlur = _this$props3.fireOnBlur,
          value = _this$props3.value;

      _this.setState({
        displayValue: finalFireOnBlur ? value : newValue
      }); // Use custom validation function if provided by consumer


      if (validation && newValue !== '') {
        if (!validation(newValue)) {
          return; // ignore input if invalid
        }

        (!fireOnBlur || finalFireOnBlur && Number(newValue) !== Number(value)) && (onChange == null ? void 0 : onChange(newValue));
      } else if (DEFAULT_VALIDATION.test(newValue)) {
        (!fireOnBlur || finalFireOnBlur && Number(newValue) !== Number(value)) && (onChange == null ? void 0 : onChange(newValue));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onValueChange", function (newValue) {
      var onValueChange = _this.props.onValueChange;

      var _checkValue = checkValue(newValue, _this.props),
          value = _checkValue.value,
          message = _checkValue.message,
          bound = _checkValue.bound;

      _this.setState({
        displayValue: newValue,
        message: message,
        bound: bound
      }); // if the input is or can be valid


      if (value !== undefined) {
        // if there is additional processing, call it
        onValueChange && onValueChange(value, newValue);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onValueAccept", function (newValue) {
      var _this$props4 = _this.props,
          value = _this$props4.value,
          onValueAccept = _this$props4.onValueAccept;
      var oldValue = fixupValue(value, _this._useOnValueCallbacks);

      var _checkValue2 = checkValue(newValue, _this.props),
          newBoundValue = _checkValue2.value;

      var _checkValue3 = checkValue(oldValue, _this.props),
          oldBoundValue = _checkValue3.value,
          message = _checkValue3.message,
          bound = _checkValue3.bound;

      _this.setState({
        displayValue: oldValue,
        message: message,
        bound: bound
      }); // check if the old input does not match the new input
      //    if both old and new are valid non-empty values compare for match as numbers
      //       else compare for match as strings
      // this may result in a callback where the boundValue has not changed even though the value has


      if (oldBoundValue && oldValue.length && newBoundValue && newValue.length ? Number(oldValue) !== Number(newValue) : oldValue !== newValue) {
        // if there is additional processing
        onValueAccept && onValueAccept(newBoundValue, newValue);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputToRender", function (props) {
      var _this$props5 = _this.props,
          min = _this$props5.min,
          max = _this$props5.max,
          ltMax = _this$props5.ltMax,
          gtMin = _this$props5.gtMin,
          step = _this$props5.step;
      var bound = _this.state.bound; // this is not quite right but the best Carbon has to address ltMax and gtMin

      var mappedMin = !bound && min !== undefined ? min + (gtMin ? step : 0) : undefined;
      var mappedMax = !bound && max !== undefined ? max - (ltMax ? step : 0) : undefined;
      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.NumberInput, (0, _extends2["default"])({}, props, {
        min: mappedMin,
        max: mappedMax,
        step: step
      }));
    });
    _this.state = {
      displayValue: undefined,
      message: undefined,
      bound: false
    };
    return _this;
  }

  NumberInput.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var value = props.value,
        onValueChange = props.onValueChange,
        onValueAccept = props.onValueAccept;

    if (state.value !== value) {
      var fixedValue = fixupValue(value, !!onValueChange || !!onValueAccept);

      var _checkValue4 = checkValue(fixedValue, props),
          message = _checkValue4.message,
          bound = _checkValue4.bound;

      return {
        displayValue: fixedValue,
        message: message,
        bound: bound,
        value: value
      };
    }

    return null;
  } // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed
  ;

  var _proto = NumberInput.prototype;

  _proto.focus = function focus() {
    var disabled = this.props.disabled;
    !disabled && this._input && this._input.focus();
  };

  _proto._constrainedValue = function _constrainedValue(value) {
    var _this$props6 = this.props,
        min = _this$props6.min,
        max = _this$props6.max,
        scale = _this$props6.scale,
        gtMin = _this$props6.gtMin,
        ltMax = _this$props6.ltMax;

    if (!value || isNaN(value)) {
      return '';
    }

    var scaleValue = Math.pow(10, scale); // ES6 syntax for Math.pow(10, scale);

    var number = Math.floor(Number(value) * scaleValue) / scaleValue;

    if (min != null) {
      var scaledMin = Math.floor(min * scaleValue) / scaleValue;
      number = Math.max(scaledMin, number);

      if (gtMin && number === scaledMin) {
        return String(number + Math.pow(10, -scale));
      }
    }

    if (max != null) {
      var scaledMax = Math.floor(max * scaleValue) / scaleValue;
      number = Math.min(scaledMax, number);

      if (ltMax && number === scaledMax) {
        return String(number - Math.pow(10, -scale));
      }
    }

    return String(number);
  };

  _proto.render = function render() {
    // extract props that are to be manipulated or not passed down
    var _this$props7 = this.props,
        min = _this$props7.min,
        max = _this$props7.max,
        ltMax = _this$props7.ltMax,
        gtMin = _this$props7.gtMin,
        step = _this$props7.step,
        scale = _this$props7.scale,
        validation = _this$props7.validation,
        className = _this$props7.className,
        onChange = _this$props7.onChange,
        onBlur = _this$props7.onBlur,
        validationErrorText = _this$props7.validationErrorText,
        hasValidationError = _this$props7.hasValidationError,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props7, ["min", "max", "ltMax", "gtMin", "step", "scale", "validation", "className", "onChange", "onBlur", "validationErrorText", "hasValidationError"]);
    var _this$state = this.state,
        displayValue = _this$state.displayValue,
        message = _this$state.message;
    var classNames = (0, _utils.classnames)("" + STYLE_CLASS);
    var mappedMessage = this._useOnValueCallbacks && message ? message : undefined;
    return (
      /*#__PURE__*/
      // ideally baseInput is only a temporary wrapper to handle error handling
      // as such the only props that should need to be sent to it are those dealing with message handling
      _react["default"].createElement(_baseinput["default"], (0, _extends2["default"])({
        inputToRender: this._inputToRender,
        id: "number-input",
        "data-tid": STYLE_CLASS
      }, sanitize(others, NumberInput), getInheritedProps(others, _baseinput["default"]), {
        className: classNames + " " + className,
        ref: this._ref,
        value: displayValue,
        onBlur: this._useOnValueCallbacks ? onBlur : this._onBlur,
        onChange: this._useOnValueCallbacks ? onChange : this._onChange,
        onValueChange: this._useOnValueCallbacks ? this._onValueChange : undefined,
        onValueAccept: this._useOnValueCallbacks ? this._onValueAccept : undefined,
        validationErrorText: mappedMessage || validationErrorText,
        hasValidationError: mappedMessage ? true : hasValidationError,
        type: "number"
      }))
    );
  };

  return NumberInput;
}(_react.Component);

exports["default"] = NumberInput;
(0, _defineProperty2["default"])(NumberInput, "propTypes", (0, _extends2["default"])({}, _baseinput["default"].propTypes, {
  // these props have a different definition then the baseInput props
  type: _propTypes["default"].oneOf([]),
  // these props are in addition to the baseInput props
  max: _propTypes["default"].number,
  ltMax: _propTypes["default"].bool,
  gtMin: _propTypes["default"].bool,
  min: _propTypes["default"].number,
  step: _propTypes["default"].number,
  scale: _propTypes["default"].number,
  validation: _propTypes["default"].func
}));
(0, _defineProperty2["default"])(NumberInput, "defaultProps", {
  scale: 10,
  className: '',
  style: {},
  step: 1,
  allowEmpty: false
});

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _NumberInputResources = _interopRequireDefault(__webpack_require__(367));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// eslint-disable-line
var _default = new _utils.StringResource(_NumberInputResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

var amdi18n={"__root":{"empty":"Enter a number.","max":"Enter a number less than or equal to %{value}.","maxLT":"Enter a number less than %{value}.","min":"Enter a number greater than or equal to %{value}.","minGT":"Enter a number greater than %{value}.","scale":"Enter a number with a scale of less than or equal to %{value}.","scale0":"Enter an integer number."},"__cs":{"empty":"Zadejte platné číslo.","max":"Zadejte číslo, které bude menší nebo rovno %{value}.","maxLT":"Zadejte číslo, které bude menší než %{value}.","min":"Zadejte číslo, které bude větší nebo rovno %{value}.","minGT":"Zadejte číslo, které bude větší než %{value}.","scale":"Zadejte číslo s počtem číslic, který bude menší nebo roven %{value}.","scale0":"Zadejte celé číslo."},"__da":{"empty":"Angiv et gyldigt nummer.","max":"Angiv et tal, der er mindre end eller lig med %{value}.","maxLT":"Angiv et tal, der er mindre end %{value}.","min":"Angiv et tal, der er større end eller lig med %{value}.","minGT":"Angiv et tal, der er større end %{value}.","scale":"Angiv et tal i en skala med mindre end eller lig med %{value}.","scale0":"Angiv et heltal."},"__de":{"empty":"Geben Sie eine gültige Zahl ein. ","max":"Geben Sie eine Zahl kleiner-gleich %{value} ein. ","maxLT":"Geben Sie eine Zahl kleiner als %{value} ein. ","min":"Geben Sie eine Zahl größer-gleich %{value} ein. ","minGT":"Geben Sie eine Zahl größer als %{value} ein. ","scale":"Geben Sie eine Zahl mit einer Anzahl von Kommastellen kleiner-gleich %{value} ein.","scale0":"Geben Sie eine ganze Zahl ein. "},"__es":{"empty":"Escriba un número válido. ","max":"Escriba un número menor que o igual a %{value}.","maxLT":"Escriba un número menor que %{value}.","min":"Escriba un número mayor que o igual a %{value}.","minGT":"Escriba un número mayor que %{value}.","scale":"Escriba un número con una escala menor que o igual a %{value}.","scale0":"Escriba un número entero."},"__fi":{"empty":"Anna kelvollinen luku.","max":"Anna luku, joka on pienempi tai yhtä suuri kuin %{value}.","maxLT":"Anna luku, joka on pienempi kuin %{value}.","min":"Anna luku, joka on suurempi tai yhtä suuri kuin %{value}.","minGT":"Anna luku, joka on suurempi kuin %{value}.","scale":"Anna luku, jonka asteikko on pienempi tai yhtä suuri kuin %{value}.","scale0":"Anna kokonaisluku."},"__fr":{"empty":"Entrez un nombre valide.","max":"Entrez un nombre inférieur ou égal à %{value}.","maxLT":"Entrez un nombre inférieur à %{value}.","min":"Entrez un nombre supérieur ou égal à %{value}.","minGT":"Entrez un nombre supérieur à %{value}.","scale":"Entrez un nombre avec une échelle inférieure ou égale à %{value}.","scale0":"Entrez un nombre entier."},"__hr":{"empty":"Molim, unesite važeći broj.","max":"Unesite broj manji ili jednak %{value}.","maxLT":"Unesite broj manji od %{value}.","min":"Unesite broj veći ili jednak %{value}.","minGT":"Unesite broj veći od %{value}.","scale":"Unesite broj na skali manji ili jednak  %{value}.","scale0":"Unesite cijeli broj."},"__hu":{"empty":"Adjon meg egy érvényes számot.","max":"Adjon meg egy legfeljebb %{value} értékű számot.","maxLT":"Adjon meg egy %{value} értéknél kisebb számot.","min":"Adjon meg egy legalább %{value} értékű számot.","minGT":"Adjon meg egy %{value} értéknél nagyobb számot.","scale":"Adjon meg egy számot legfeljebb %{value} skálán. ","scale0":"Adjon meg egy egész számot. "},"__it":{"empty":"Immettere un numero valido.","max":"Immettere un numero minore o uguale a %{value}.","maxLT":"Immettere un numero minore di %{value}.","min":"Immettere un numero maggiore o uguale a %{value}.","minGT":"Immettere un numero maggiore di %{value}.","scale":"Immettere un numero con una scala minore o uguale a %{value}.","scale0":"Immettere un numero intero."},"__ja":{"empty":"有効な数を入力してください。","max":"%{value} 以下の値を入力してください。","maxLT":"%{value} 未満の値を入力してください。","min":"%{value} 以上の値を入力してください。","minGT":"%{value} より大きい値を入力してください。","scale":"小数部桁数が %{value} 以内の数を入力してください。","scale0":"整数を入力してください。"},"__kk":{"empty":"Жарамды санды енгізіңіз.","max":"%{value}-дан кем немесе оған тең санды енгізіңіз.","maxLT":"%{value}-дан кем санды енгізіңіз.","min":"%{value}-дан үлкен немесе оған тең санды енгізіңіз.","minGT":"%{value}-дан үлкен санды енгізіңіз.","scale":"%{value}-дан кем немесе оған тең сандық разрядымен санды енгізіңіз.","scale0":"Бүтін санды енгізіңіз."},"__ko":{"empty":"올바른 숫자를 입력하십시오.","max":"%{value}보다 작거나 같은 숫자를 입력하십시오.","maxLT":"%{value}보다 작은 숫자를 입력하십시오.","min":"%{value}보다 크거나 같은 숫자를 입력하십시오.","minGT":"%{value}보다 큰 숫자를 입력하십시오.","scale":"%{value}보다 작거나 같은 스케일의 숫자를 입력하십시오.","scale0":"정수를 입력하십시오."},"__nb":{"empty":"Oppgi et gyldig tall.","max":"Oppgi et tall som er mindre enn eller lik %{value}.","maxLT":"Oppgi et tall som er mindre enn %{value}.","min":"Oppgi et tall som er større enn eller lik %{value}.","minGT":"Oppgi et tall som er større enn %{value}.","scale":"Oppgi et tall med en skala som er mindre enn eller lik %{value}.","scale0":"Oppgi et heltall."},"__nl":{"empty":"Geef een geldig getal op.","max":"Geef een getal op dat kleiner is dan of gelijk is aan %{value}.","maxLT":"Geef een getal op dat kleiner is dan %{value}.","min":"Geef een getal op dat groter is dan of gelijk is aan %{value}.","minGT":"Geef een getal op dat groter is dan %{value}.","scale":"Geef een getal op met een schaal die kleiner is dan of gelijk is aan %{value}.","scale0":"Geef een geheel getal op."},"__no":{"empty":"Oppgi et gyldig tall.","max":"Oppgi et tall som er mindre enn eller lik %{value}.","maxLT":"Oppgi et tall som er mindre enn %{value}.","min":"Oppgi et tall som er større enn eller lik %{value}.","minGT":"Oppgi et tall som er større enn %{value}.","scale":"Oppgi et tall med en skala som er mindre enn eller lik %{value}.","scale0":"Oppgi et heltall."},"__pl":{"empty":"Wprowadź poprawną liczbę.","max":"Wprowadź liczbę mniejszą lub równą %{value}.","maxLT":"Wprowadź liczbę mniejszą niż %{value}.","min":"Wprowadź liczbę większą lub równą %{value}.","minGT":"Wprowadź liczbę większą niż %{value}.","scale":"Wprowadź liczbę o skali nie większej niż %{value}.","scale0":"Wprowadź liczbę całkowitą."},"__pt":{"empty":"Insira um número válido.","max":"Insira um número menor ou igual a %{value}.","maxLT":"Insira um número menor que %{value}.","min":"Digite um número maior ou igual a %{value}.","minGT":"Insira um número maior que %{value}.","scale":"Insira um número com uma escala menor ou igual a %{value}.","scale0":"Insira um número inteiro."},"__pt-br":{"empty":"Insira um número válido.","max":"Insira um número menor ou igual a %{value}.","maxLT":"Insira um número menor que %{value}.","min":"Digite um número maior ou igual a %{value}.","minGT":"Insira um número maior que %{value}.","scale":"Insira um número com uma escala menor ou igual a %{value}.","scale0":"Insira um número inteiro."},"__ro":{"empty":"Vă rugăm introduceţi un număr valid. ","max":"Introduceţi un număr mai mic sau egal cu %{value}.","maxLT":"Introduceţi un număr mai mic decât %{value}.","min":"Introduceţi un număr mai mare sau egal cu %{value}.","minGT":"Introduceţi un număr mai mare decât %{value}.","scale":"Introduceţi un număr cu o scală mai mică sau egală cu %{value}.","scale0":"Introduceţi un număr întreg."},"__ru":{"empty":"Введите допустимое число.","max":"Введите число меньше или равное %{value}.","maxLT":"Введите число меньше %{value}.","min":"Введите число больше или равное %{value}.","minGT":"Введите число больше %{value}.","scale":"Введите число с числом разрядов меньше или равным %{value}.","scale0":"Введите целое число."},"__sl":{"empty":"Vnesite veljavno število.","max":"Vnesite število, manjše od ali enako %{value}.","maxLT":"Vnesite število, manjše od %{value}.","min":"Vnesite število, večje od ali enako %{value}.","minGT":"Vnesite število, večje od %{value}.","scale":"Vnesite število z merilom, ki je manjše od ali enako %{value}.","scale0":"Vnesite celo število."},"__sv":{"empty":"Ange ett giltigt tal.","max":"Ange ett tal som är mindre än eller lika med %{value}.","maxLT":"Ange ett tal som är mindre än %{value}.","min":"Ange ett tal som är större än eller lika med %{value}.","minGT":"Ange ett tal som är större än %{value}.","scale":"Ange ett tal i en skala mindre än eller lika med %{value}.","scale0":"Ange ett heltal."},"__th":{"empty":"โปรดป้อนตัวเลขที่ถูกต้อง","max":"ป้อนตัวเลขที่น้อยกว่าหรือเท่ากับ %{value}","maxLT":"ป้อนตัวเลขที่น้อยกว่า %{value}","min":"ป้อนตัวเลขที่มากกว่าหรือเท่ากับ %{value}","minGT":"ป้อนตัวเลขที่มากกว่า %{value}","scale":"ป้อนตัวเลขที่มีสเกลน้อยกว่าหรือเท่ากับ %{value}","scale0":"ป้อนเลขจำนวนเต็ม"},"__tr":{"empty":"Lütfen geçerli bir sayı girin.","max":"Bundan küçük ya da buna eşit bir sayı girin: %{value}.","maxLT":"Bundan küçük bir sayı girin: %{value}.","min":"Bundan büyük ya da buna eşit bir sayı girin: %{value}.","minGT":"Bundan büyük bir sayı girin: %{value}.","scale":"Bu ölçekten küçük ya da buna eşit bir sayı girin: %{value}.","scale0":"Tam sayı girin. "},"__zh":{"empty":"请输入有效数字。","max":"请输入小于或等于 %{value} 的数字。","maxLT":"请输入小于 %{value} 的数字。","min":"请输入大于或等于 %{value} 的数字。","minGT":"请输入大于 %{value} 的数字。","scale":"请输入小数位数小于或等于 %{value} 的数字。","scale0":"请输入整数。"},"__zh-cn":{"empty":"请输入有效数字。","max":"请输入小于或等于 %{value} 的数字。","maxLT":"请输入小于 %{value} 的数字。","min":"请输入大于或等于 %{value} 的数字。","minGT":"请输入大于 %{value} 的数字。","scale":"请输入小数位数小于或等于 %{value} 的数字。","scale0":"请输入整数。"},"__zh-hk":{"empty":"請輸入有效數字。","max":"輸入小於或等於 %{value} 的數字。","maxLT":"輸入小於 %{value} 的數字。","min":"輸入大於或等於 %{value} 的數字。","minGT":"輸入大於 %{value} 的數字。","scale":"輸入小於或等於 %{value} 的小數位數。","scale0":"輸入整數。"},"__zh-mo":{"empty":"請輸入有效數字。","max":"輸入小於或等於 %{value} 的數字。","maxLT":"輸入小於 %{value} 的數字。","min":"輸入大於或等於 %{value} 的數字。","minGT":"輸入大於 %{value} 的數字。","scale":"輸入小於或等於 %{value} 的小數位數。","scale0":"輸入整數。"},"__zh-sg":{"empty":"请输入有效数字。","max":"请输入小于或等于 %{value} 的数字。","maxLT":"请输入小于 %{value} 的数字。","min":"请输入大于或等于 %{value} 的数字。","minGT":"请输入大于 %{value} 的数字。","scale":"请输入小数位数小于或等于 %{value} 的数字。","scale0":"请输入整数。"},"__zh-tw":{"empty":"請輸入有效數字。","max":"輸入小於或等於 %{value} 的數字。","maxLT":"輸入小於 %{value} 的數字。","min":"輸入大於或等於 %{value} 的數字。","minGT":"輸入大於 %{value} 的數字。","scale":"輸入小於或等於 %{value} 的小數位數。","scale0":"輸入整數。"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(369);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "\n", ""]);

// exports
exports.locals = {
	"numberInputClassName": "\"ba-common-numberInput\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[363,0]]]);
});